import { render, staticRenderFns } from "./WeekHandler.vue?vue&type=template&id=6929b760&scoped=true"
import script from "./WeekHandler.vue?vue&type=script&lang=js"
export * from "./WeekHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929b760",
  null
  
)

export default component.exports